import { Button } from "@material-ui/core"
import { useQuickPurchaseContext } from "components/QuickPurchasePage/QuickPurchaseContext"
import styled from "styled-components"

// NOTE: Keeping for future development
const StyledStickyBottomContainer = styled("div")<{ $visible?: boolean }>`
  display: ${(p) => (p?.$visible ? "flex" : "none")};
  justify-content: space-between;
  align-items: flex-end;
  border-radius: 16px 16px 0px 0px;
  background: var(--White, #fff);
  box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.12);
  position: sticky;
  bottom: 0;
  z-index: 5;
  padding: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: none;
  }
`

const StyledSubmitButton = styled(Button).attrs({ variant: "contained" })`
  display: flex;
  width: 184px;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  background: var(--Yellow, #ffbc0d);
  color: #000;

  &.disabled {
    background-color: #f7f7f7;
    color: #2d2d2d;
  }
`

const StyledByline = styled.p`
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: NarkisBlock;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.3px;
  margin: 0;
`

const StyledAmount = styled.h4`
  color: var(--Black, var(--Primary-Black, #000));
  font-family: NarkisBlock;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.6px;
  text-align: right;
  margin: 0;
`

const StyledSubtext = styled.p`
  margin: 0;
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: NarkisBlock;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.21px;
`

const StyledCurrency = styled.span`
  font-size: 26px;
`

const StyledCostSummary = styled.div``

const StickyBottomSummary = () => {
  const {
    priceAfterDiscount,
    discount,
    validationPassed,
    submitFormTrigger,
    showStickyBottom,
  } = useQuickPurchaseContext()

  return (
    <StyledStickyBottomContainer $visible={showStickyBottom}>
      <StyledCostSummary>
        <StyledByline>סה״כ לתשלום</StyledByline>
        <StyledAmount>
          {priceAfterDiscount || 0} <StyledCurrency>₪</StyledCurrency>
        </StyledAmount>
        {discount > 0 && (
          <StyledSubtext>לאחר שווי הנחה של {discount || 0}%</StyledSubtext>
        )}
      </StyledCostSummary>
      <StyledSubmitButton
        type="submit"
        // disabled={!validationPassed}
        className={!validationPassed ? "disabled" : ""}
        onClick={submitFormTrigger}
      >
        הכל נכון, הלאה
      </StyledSubmitButton>
    </StyledStickyBottomContainer>
  )
}

export default StickyBottomSummary
